module.exports = __webpack_public_path__ + "static/assets/e22f33fb5cb34fa3838b2adbf419b064.svg";